import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue";
import _imports_0 from '../assets/page-image/ryzz/banner.png';
const _hoisted_1 = {
  class: "ryzz-page"
};
const _hoisted_2 = {
  class: "content-wrapper"
};
const _hoisted_3 = {
  class: "left-section"
};
const _hoisted_4 = {
  class: "scroll-container"
};
const _hoisted_5 = ["src", "alt"];
const _hoisted_6 = {
  class: "card-name"
};
const _hoisted_7 = {
  key: 1,
  class: "no-data"
};
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import SectionTitle from '@/components/SectionTitle.vue';
import Footer from '@/components/Footer.vue';
import { getHonorQualifications } from '@/api/honor';
export default /*@__PURE__*/_defineComponent({
  __name: 'Ryzz',
  setup(__props) {
    const router = useRouter();
    // 荣誉证书列表数据
    const honorList = ref([]);
    const handleSelect = item => {
      // console.log(item);
      router.push({
        path: item
      });
    };
    const handleMoreClick = () => {
      console.log('更多按钮被点击');
    };
    // 获取荣誉证书列表
    const fetchHonorList = async () => {
      try {
        const res = await getHonorQualifications(1); // 1-荣誉证书
        honorList.value = res.data || [];
      } catch (error) {
        console.error('获取荣誉证书列表失败：', error);
      }
    };
    onMounted(() => {
      fetchHonorList();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "banner-wrapper"
      }, [_createElementVNode("div", {
        class: "banner-container"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "荣誉资质",
        class: "banner"
      })])], -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(SectionTitle, {
        title: "荣誉资质",
        onMoreClick: handleMoreClick,
        "show-more": false
      }), _createElementVNode("div", _hoisted_4, [honorList.value.length > 0 ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(Math.ceil(honorList.value.length / 3), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "item-row",
          key: index
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(honorList.value.slice(index * 3, index * 3 + 3), honor => {
          return _openBlock(), _createElementBlock("div", {
            class: "card",
            key: honor.id
          }, [_createElementVNode("img", {
            src: honor.url,
            alt: honor.title,
            class: "card-img"
          }, null, 8, _hoisted_5), _createElementVNode("div", _hoisted_6, _toDisplayString(honor.label), 1)]);
        }), 128))]);
      }), 128)) : (_openBlock(), _createElementBlock("div", _hoisted_7, "暂无数据"))])])]), _createVNode(Footer)]);
    };
  }
});